<template>
    <div class="default-page">

        <div class="buttons">
            <button class="button btn-primary" @click="saveForm">
                {{ $ml.get('buttons.save') }}
            </button>

            <button class="button btn-primary" @click="goToList">
                {{ $ml.get('buttons.back') }}
            </button>

            <button class="button btn-danger"
                    v-if="this.element && this.element.id"
                    @click="openConfirmDelete = true">
                {{ $ml.get('buttons.delete') }}
            </button>

            <button v-for="(button, index) in buttons"
                    :class="['button', button.class]"
                    @click="button.function">
                {{ button.label }}
            </button>
        </div>

        <div class="block" :key="change">
            <div class="title">{{ pageTitle }}</div>
            <div class="body flex-row-wrap">
                <div :class="getClass(key)"
                     v-for="(label, key) in labels">
                    <div class="formBlock">
                        <p :class="['label', {'required' : form_required.includes(label)}]">
                            {{ form_labels[label] }}
                            <template v-if="form_required.includes(label)">*</template>
                        </p>
                        <template v-if="getTypeForm(label) === 'number'">
                            <input type="number"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'boolean'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    v-model="element[label]"
                                    :options="selectBooleanOptions"
                                    :placeholder="form_labels[label]">
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'string'">
                            <div class="input disabled" v-if="element[label]">{{ element[label] }}</div>
                        </template>
                        <template v-if="getTypeForm(label) === 'date'">
                            <date-picker
                                valueType="format"
                                format="DD.MM.YYYY"
                                v-model="element[label]"
                                :placeholder="form_labels[label]"
                            />
                        </template>
                        <template v-if="getTypeForm(label) === 'link'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'textarea'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'input'">
                            <input type="text"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'select'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    :label="getSelectLabel(label)"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'select-tags'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    :multiple="true"
                                    :taggable="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="title">{{ lang.labels.permissions_table }}</div>
            <div class="body">

                <button class="button btn-primary" @click="openSelectPermission = true">
                    <span class="icon ico-i icon-add"></span>
                    <span class="label">{{ $ml.get('buttons.add') }}</span>
                </button>

                <table class="table">
                    <thead>
                        <tr>
                            <th class="text-l">{{ lang.labels.permission }}</th>
                            <th>{{ lang.labels.value }}</th>
                            <th>#</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in plan_permissions" :key="index">
                            <td class="text-l">{{ item.permission.title }}</td>
                            <td>
                                <input class="input" type="number"
                                       v-if="item.permission.type === 2"
                                       v-model="item.value"
                                       :placeholder="lang.labels.value">
                            </td>
                            <td>
                                <button class="button btn-danger" @click="deletePermission(index)">
                                    <span class="icon ico-i icon-delete"></span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <ModalWindow :open="openSelectPermission"
                     @closeModal="openSelectPermission = false">
            <template slot="title">
                {{ lang.labels.select_permission }}
            </template>
            <template slot="body">
                <div class="defaultMultiselect">
                    <Multiselect
                        track-by="id"
                        label="title"
                        :preserve-search="true"
                        v-model="selectedPermission"
                        :options="permissions">
                        <template slot="noResult">{{ $ml.get('interface.no_result') }}</template>
                        <template slot="noOptions">{{ $ml.get('interface.no_options') }}</template>
                    </Multiselect>
                </div>
            </template>
            <template slot="buttons">
                <button class="button btn-success" @click="addPermission">
                    {{ lang.labels.add_permission }}
                </button>
            </template>
        </ModalWindow>

        <ModalWindow :open="openConfirmDelete"
                     @closeModal="openConfirmDelete = false">
            <template slot="title">
                {{ $ml.get('interface.confirm_action') }}
            </template>
            <template slot="body">
                {{ $ml.get('interface.confirm_action_delete') }}
            </template>
            <template slot="buttons">
                <button class="button btn-danger" @click="deleteForm">
                    {{ $ml.get('buttons.delete') }}
                </button>
            </template>
        </ModalWindow>

    </div>
</template>

<script>
import FormMethodsDefault from "../Utils/Page/Form/FormMethodsDefault";

export default {
    name: "Form",
    mixins: [FormMethodsDefault],
    data() {
        return {
            openSelectPermission: false,
            selectedPermission: null,

            lang: this.$ml.get('pages.plan'),
            buttons: [
            ],

            typeForm: {
                active: 'boolean',
            },
            form_required: ['slug', 'title', 'price'],

            pageRouteList: 'plan',
            pageRouteEdit: 'plan.edit',
            pageApi: 'plan',

            plan_permissions: [],
            permissions: [],
        }
    },
    methods: {
        appendDataSave() {
            return {
                plan_permissions: this.plan_permissions
            }
        },
        deletePermission(index) {
            this.plan_permissions.splice(index, 1)
        },
        addPermission() {
            let index = this.plan_permissions.findIndex(item => item.permission_id === this.selectedPermission.id)
            if (index === -1) {
                this.plan_permissions.push({
                    permission: this.selectedPermission,
                    permission_id: this.selectedPermission.id,
                    value: null
                })
            }
            this.selectedPermission = null
            this.openSelectPermission = false
        },
        getClass(key) {
            return 'w33'
        },
        setExtraData(data) {
            this.plan_permissions = data.plan_permissions
            this.permissions = data.permissions
        },
    }
}
</script>

<style scoped>

</style>
